/** Letters and spaces only (no numbers or special characters) */
export const LOCATION_NAME_PATTERN = /^[A-Za-z]+(?:\s+[A-Za-z]+)*$/;

/** Letters and numbers; optional single spaces between segments (e.g. EC1A 3) */
export const PINCODE_PATTERN = /^[A-Z0-9]+(?:\s[A-Z0-9]+)*$/;

export const sanitizeLocationInput = (value) => value.replace(/[^A-Za-z\s]/g, "");

export const sanitizePincodeInput = (value) =>
  value.replace(/[^A-Za-z0-9\s]/g, "").toUpperCase();

export const validateLocationName = (value) => {
  const trimmed = value.trim().replace(/\s+/g, " ");

  if (!trimmed) {
    return "Location is required";
  }

  if (!LOCATION_NAME_PATTERN.test(trimmed)) {
    return "Location can only contain letters and spaces (no numbers or special characters)";
  }

  return null;
};

export const validatePincode = (value) => {
  const trimmed = value.trim().replace(/\s+/g, " ");

  if (!trimmed) {
    return "Pincode is required";
  }

  const normalized = trimmed.toUpperCase();

  if (!PINCODE_PATTERN.test(normalized)) {
    return "Pincode can only contain letters and numbers";
  }

  return null;
};

export const formatPincodeForApi = (value) => value.trim().replace(/\s+/g, " ").toUpperCase();
